import axios, { AxiosInstance } from "axios";

let baseURL: string | undefined;

switch (process.env.NODE_ENV) {
  case "development":
    baseURL = process.env.REACT_APP_API_URL_DEV;
    break;
  case "production":
    baseURL = process.env.REACT_APP_API_URL_PROD;
    break;
  case "test":
    baseURL = process.env.REACT_APP_API_URL_TEST;
    break;
  default:
    throw new Error(`Unknown NODE_ENV: ${process.env.NODE_ENV}`);
}

const authToken = localStorage.getItem("authToken") || "";

export const apiClient: AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
